import { Box, type SxProps, type Theme } from '@mui/material';
import React from 'react';

import { spaces } from '../../assets/styles/themes/tokens';
import CustomDialog from '../Dialog/CustomDialog';
import CopyLinkField from './CopyLinkField';
import QrCode from './QrCode';

interface OwnProps {
	title: string;
	onClose: () => void;
	open: boolean;
	linkUrl: string;
	qrImageName: string;
	onQrDownload?: () => void;
	onLinkCopy?: () => void;
	subTitle?: string;
	sx?: SxProps<Theme>;
}

const ShareDialog: React.FC<OwnProps> = (props) => {
	const { title, subTitle, linkUrl, qrImageName, onClose, open, onQrDownload, onLinkCopy, sx } =
		props;

	return (
		<CustomDialog
			dataTestId="share-dialog"
			open={open}
			onClose={onClose}
			title={title}
			subTitle={subTitle}
			dialogProps={{ sx }}
		>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: spaces.lg,
				}}
			>
				<CopyLinkField link={linkUrl} onCopy={onLinkCopy} />
				<QrCode link={linkUrl} imageName={qrImageName} onDownload={onQrDownload} />
			</Box>
		</CustomDialog>
	);
};

export default ShareDialog;
